export default __webpack_public_path__ + "static/media/default-overview.15a824ef.png";